import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Briefcase, FileText } from 'lucide-react';

/**
 * Tab strip rendered at the top of both ClientsPage and ContractsPage.
 * Lets the user flip between the two related views without going back to
 * the dashboard. Both pages remain independently routable, so existing
 * deep links keep working.
 */
export function ClientsContractsTabs() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isContracts = pathname.startsWith('/dashboard/contracts');
  const isClients = pathname.startsWith('/dashboard/clients');

  const tabs = [
    {
      to: '/dashboard/clients',
      active: isClients,
      icon: Briefcase,
      label: t('dashboard.modules.clients'),
    },
    {
      to: '/dashboard/contracts',
      active: isContracts,
      icon: FileText,
      label: t('dashboard.modules.contracts'),
    },
  ];

  return (
    <div className="border-b border-border bg-muted/20">
      <div className="max-w-7xl mx-auto px-6">
        <div role="tablist" className="flex gap-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <Link
                key={tab.to}
                to={tab.to}
                role="tab"
                aria-selected={tab.active}
                className={`relative inline-flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors ${
                  tab.active
                    ? 'text-foreground'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                <Icon className="h-4 w-4" />
                <span>{tab.label}</span>
                {tab.active && (
                  <span className="absolute bottom-0 inset-x-0 h-0.5 bg-gold" />
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
